"use strict";

export default class DriverGroups {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  getDriverGroups(driverIds, groupIds, searchTerm, paging, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/driver-groups";

    let param = [];
    param.push.apply(param, this.API.getPagingQuery(paging));
    if (searchTerm) param.push("searchTerm=" + searchTerm);

    // todo: group id and driver id arrays are not currently implemented yet on the server side.
    // todo: leave these here as placeholders for when they do get put in
    param.push.apply(param, this.API.getArrayQuery("driverId", driverIds));
    param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));

    if (searchTerm) param.push("searchTerm=" + searchTerm);

    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((drivers) => {
        //console.log("drivers groups: ", drivers);
        deferred.resolve(drivers);

      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  getById(groupId, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/driver-groups/" + groupId;

    let param = [];
    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((vehicle) => deferred.resolve(vehicle))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }
}

DriverGroups.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-fleetlink/fleetlink.driver-groups.js